
import { useTranslation } from '../hooks';
import { SingleSelection } from '.';
import { SelectChangeEvent } from './MuiGenerals';
import { EnumQuestionType } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/Master';

export default function QuestionTypeSelection({
  onChange,
  value,
  clearSelect,
}: {
  onChange: (e: SelectChangeEvent) => void;
  value: string;
  clearSelect: () => void;
}) {
  const { tc, t } = useTranslation('EnumQuestionType');

  return (
    <SingleSelection
      label={tc('phSelection', { fieldName: tc('question_type') })}
      value={value}
      onChange={onChange}
      enumData={EnumQuestionType}
      clearSelect={clearSelect}
      nameFn={(item) => t(item)}
    />
  );
}
